
import React from "react";
import { Mail, Phone, MapPin } from 'lucide-react';
import { motion } from "framer-motion";


const fadeInUp = {
    hidden: { opacity: 0, y: 40 },
    visible: (i = 1) => ({
        opacity: 1,
        y: 0,
        transition: { delay: i * 0.2, duration: 0.7, ease: "easeOut" }
    })
};

const Contact = ({ id }) => (
    <section id={id} className="py-20 px-4">
        <div className="container mx-auto">
                    <motion.h2
                        className="text-3xl md:text-4xl font-bold text-center mb-12 text-white"
                        initial="hidden"
                        animate="visible"
                        variants={fadeInUp}
                        custom={1}
                    >
                        Get In Touch
                        <div className="w-24 h-1 bg-cyan-400 mx-auto mt-2 rounded"></div>
                    </motion.h2>
                    <motion.div
                        className="max-w-3xl mx-auto text-center"
                        initial="hidden"
                        animate="visible"
                        variants={fadeInUp}
                        custom={2}
                    >
                <motion.p
                    className="text-lg text-gray-300 mb-8"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.5 }}
                    variants={fadeInUp}
                    custom={3}
                >
                    I'm currently open to new opportunities and collaborations. Feel free to reach out to me!
                </motion.p>
                <div className="flex flex-col md:flex-row justify-center items-center gap-8">
                    <motion.div
                        className="flex items-center gap-3 text-lg"
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, amount: 0.5 }}
                        variants={fadeInUp}
                        custom={4}
                        whileHover={{ scale: 1.08 }}
                    >
                        <Mail className="text-cyan-400" size={24} />
                        <a href="mailto:rajanbhalodiya456@gmail.com" className="hover:text-cyan-400 transition-colors">
                            rajanbhalodiya456@gmail.com
                        </a>
                    </motion.div>
                    <motion.div
                        className="flex items-center gap-3 text-lg"
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, amount: 0.5 }}
                        variants={fadeInUp}
                        custom={5}
                        whileHover={{ scale: 1.08 }}
                    >
                        <Phone className="text-cyan-400" size={24} />
                        <a href="tel:+919510459100" className="hover:text-cyan-400 transition-colors">
                            +91 95104 59100
                        </a>
                    </motion.div>
                </div>
                <motion.div
                    className="flex justify-center items-center gap-3 text-lg mt-6"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.5 }}
                    variants={fadeInUp}
                    custom={6}
                >
                    <MapPin className="text-cyan-400" size={24} />
                    <span>Amblash (gir), Talala, Girsomnath - 362150</span>
                </motion.div>
            </motion.div>
        </div>

    </section>
);

export default Contact;
